export function isInViewport(el) {
  if (!el) {
    return false;
  }

  var top = el.offsetTop;
  var left = el.offsetLeft;
  var width = el.offsetWidth;
  var height = el.offsetHeight;

  while (el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  }

  return (
    top < (window.pageYOffset + window.innerHeight) &&
    left < (window.pageXOffset + window.innerWidth) &&
    (top + height) > window.pageYOffset &&
    (left + width) > window.pageXOffset
    );
}

export function createYtScript() {
  const ytElement = document.getElementById('yt-api');
  if (ytElement) {
    return;
  }

  const element = document.createElement('script');
  element.id = 'yt-api';
  element.src = 'https://www.youtube.com/iframe_api';
  const firstScriptElement = document.getElementsByTagName('script')[0];
  firstScriptElement.parentNode.insertBefore(element, firstScriptElement);
}

export function getIndex(element) {
  if (!element) {
    return -1;
  }

  return [...element.parentNode.children].indexOf(element);
}